import React from 'react'
import { useFetchSubBusiness } from '../../../modules/outlet/outletHooks'
import {
  Dialog,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Typography
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { getBusinessDetails } from '../../../components/tsComponents/AuthGuard'

const SubBusinessDailog = ({ open, onClose, onSubmit }) => {
  const { data: subBusiness } = useFetchSubBusiness()
  const businessName = getBusinessDetails()?.name
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <Grid
        pl={2}
        pr={2}
        container
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="subtitle1">Select Sub Business</Typography>
        <IconButton onClick={onClose} sx={{ '&:hover': { color: 'red' } }}>
          <Close />
        </IconButton>
      </Grid>
      <Divider />
      {subBusiness?.map((option, i) => {
        if (businessName !== option.sub_business_name) {
          return (
            <MenuItem
              key={i}
              value={option.sub_business_name}
              onClick={() => {
                onSubmit(option.sub_business_name)
                onClose()
              }}
            >
              {option.sub_business_name}
            </MenuItem>
          )
        }
      })}
    </Dialog>
  )
}

export default SubBusinessDailog
